import baseComponent from "@/scripts/baseComponent";
import { mapState } from "vuex";
import EventBus from "@/event/EventBus";
const queryString = require('query-string');

export default {

    extends: baseComponent,

    props: {
        element: {
            type: Object,
            default() { return {}; }
        },
        deviceInformation: {
            type: Object,
            default() { return {}; }
        }
    },

    data() {
        return {

        };
    },

    computed: {
        ...mapState({
            listStaff: state => state.staffs,
            listServicePack: state => state.common.listServicePack,
            decentralization: state => state.auth.decentralization,
        }),
    },

    created() {

    },

    mounted() {

    },

    methods: {

    }
}